import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { motion, AnimationControls } from 'framer-motion';

interface SnapFeedNavigationProps {
  currentIndex: number;
  totalSnaps: number;
  onPrevious: () => void;
  onNext: () => void;
  controls: AnimationControls;
}

export default function SnapFeedNavigation({ 
  currentIndex, 
  totalSnaps, 
  onPrevious, 
  onNext,
  controls
}: SnapFeedNavigationProps) {
  return (
    <>
      {/* Navigation Buttons - only visible on medium screens and up */}
      <div className="absolute bottom-24 left-0 right-0 hidden md:flex justify-center space-x-8 z-10">
        <button
          onClick={() => {
            controls.start({ 
              y: window.innerHeight, 
              opacity: 0,
              transition: { duration: 0.3 }
            }).then(onPrevious);
          }}
          className="bg-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg"
        >
          <ArrowLeftIcon className="h-8 w-8 text-gray-500" />
        </button>
        
        <button
          onClick={() => {
            controls.start({ 
              y: -window.innerHeight, 
              opacity: 0,
              transition: { duration: 0.3 }
            }).then(onNext);
          }}
          className="bg-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg"
        >
          <ArrowRightIcon className="h-8 w-8 text-gray-500" />
        </button>
      </div>
      
      {/* SNAP Counter */}
      <div className="absolute bottom-14 left-0 right-0 flex justify-center">
        <div className="bg-black/50 text-white px-4 py-2 rounded-full text-sm backdrop-blur-sm">
          {currentIndex + 1} / {totalSnaps}
        </div>
      </div>
    </>
  );
}